<template>
    <div class="personSet_page">
        <div v-if="!update_success" class="passContent_infoUser">
            <div class="leftdiv"> {{$t('personSet.currentPass')}}:</div>
            <div class="rightdiv">
                <input
                    id="currentPassword"
                    ref="currentPassword"
                    type="text"
                    :placeholder="$t('personSet.placeholder')"
                    v-model="currentPassword"
                />
            </div>
            <br />
            <div class="leftdiv"> {{$t('personSet.newPass')}}:</div>
            <div class="rightdiv">
                <input
                    id="newPassword"
                    type="text"
                    :placeholder="$t('personSet.placeholder')"
                    maxlength="16"
                    v-model="newPassword"
                />
            </div>
            <br />
            <div class="leftdiv">{{$t('personSet.repeatPass')}}:</div>
            <div class="rightdiv">
                <input
                    id="repeatPassword"
                    type="text"
                    :placeholder="$t('personSet.placeholder')"
                    maxlength="16"
                    v-model="repeatPassword"
                />
            </div>
            <br />
            <button @click="updatePass()">{{$t('personSet.confirm')}}</button>
        </div>
        <div v-if="update_success" class="passContent_infoUser">
            <p class="ss_ud_tt">{{ $t("new.title43") }}</p>
            <button class="ss_ud_btn" @click="back()">{{$t('common.okButton')}}</button>
        </div>
    </div>
</template>

<script>
import md5 from "js-md5";
export default {
    data() {
        return {
            p1:0,
            p2:0,
            p3:0,
            currentPassword: null,
            newPassword: null,
            repeatPassword: null,
            update_success: false,
        };
    },
    computed: {
        mobile() {
            return this.$store.getters["header/mobile"];
        },
    },
    created() {},
    watch: {
        currentPassword: function (val) {
            this.setPwdType("currentPassword", val);
            this.$nextTick(function(){
                this.$refs.currentPassword.focus();
            })
        },
        newPassword: function (val) {
            this.setPwdType("newPassword", val);
        },
        repeatPassword: function (val) {
            this.setPwdType("repeatPassword", val);
        },
    },
    mounted() {
        window.scrollBy(0, -100);
    },
    methods: {
        setPwdType: function (id, val) {
            let len = val ? val.length : 0;
            if (len) {
                this.p1 = 1;
                document.getElementById(id).setAttribute("type", "password");
                document.getElementById(id).setAttribute("autoComplete", "new-password");
                document.getElementById("text").setAttribute("type", "text");
            } else {
                document.getElementById(id).setAttribute("type", "password");
                document.getElementById(id).setAttribute("autoComplete", "new-password");
                document.getElementById("text").setAttribute("type", "text");
                this.p1 = 0;
            }
        },
        updatePass: function () {
            // check nhập mật khẩu cũ
            if (this.currentPassword == null || this.currentPassword == "") {
                this.$el_alert_type(window.vm.$i18n.t("new.title28"), "warning");
                return;
            }
            // check nhập mật khẩu mới
            if (this.newPassword == null || this.newPassword == "") {
                this.$el_alert_type(
                    window.vm.$i18n.t("personSet.passwordNotNull"),
                    "warning"
                );
                return;
            }
            // check nhập không đúng format pass
            let passReg = new RegExp(
                /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,16}$/
            );
            if (!passReg.test(this.newPassword)) {
                this.$el_alert_type(window.vm.$i18n.t("js.passwordFormat"), "warning");
                return;
            }
            passReg = new RegExp(/^[a-zA-Z0-9_+-=*#%$]+$/);
            if (!passReg.test(this.newPassword)) {
                this.$el_alert_type(window.vm.$i18n.t("js.passwordFormat"), "warning");
                return;
            }
            // check nhập lại mật khẩu
            if (this.repeatPassword == null || this.repeatPassword == "") {
                this.$el_alert_type(window.vm.$i18n.t("js.repeatPassword"), "warning");
                return;
            }
            // check không trùng mật khẩu mới và nhập lại mật khẩu
            if (this.newPassword != this.repeatPassword) {
                this.$el_alert_type(window.vm.$i18n.t("js.different"), "warning");
                return;
            }
            // check mật khẩu cũ trùng với mật khẩu mới
            if (this.newPassword == this.currentPassword) {
                this.$el_alert_type(window.vm.$i18n.t("new.title18"), "warning");
                return;
            }

            // Lấy email
            let email = window.sessionStorage.getItem("email");
            let loginName = window.sessionStorage.getItem("loginName");

            // gọi API update
            this.$api
                .post("/personalCenter/changePasswordByEmail", {
                    oldPassword: md5(this.currentPassword),
                    newPassword: md5(this.newPassword),
                    loginName: loginName
                })
                .then((response) => {
                /// Thay đổi pass ok
                if (response.data.codeFlag == "1006") {
                    /// check trường hợp có lưu pass ở cookie
                    if (document.cookie.length > 0) {
                        var arr = window.document.cookie.split(";");
                        let passNew = "";
                        let emailNew = "";
                        let rememberNew = "";
                        for (var i = 0; i < arr.length; i++) {
                            var arr2 = arr[i].split("=");
                            if (arr2[0].replace(/^\s+|\s+$/g, "") === "remember") {
                                rememberNew = arr2[1];
                            } else if (arr2[0].replace(/^\s+|\s+$/g, "") === "email") {
                                emailNew = arr2[1];
                            } else if (arr2[0].replace(/^\s+|\s+$/g, "") === "password") {
                                passNew = arr2[1];
                            }
                        }
                        //setting expires cookies
                        if (rememberNew==1) {
                            let d = new Date();
                            d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 7);
                            window.document.cookie = "password=" + this.newPassword + ";path=/;expires=" + d.toGMTString();
                            window.document.cookie = "email=" + emailNew + ";path=/;expires=" + d.toGMTString();
                            window.document.cookie = "remember=1;path=/;expires=" + d.toGMTString();
                        }
                    }
                    this.update_success = true;
                    window.sessionStorage.setItem("passwordChangeFlag", 1);
                /// check trường hợp nhập không đúng mật khẩu
                } else if (response.data.codeFlag == "1005") {
                    this.$el_alert_type(
                        window.vm.$i18n.t("personSet.oldPasswordIncorrect"),
                        "warning"
                    );
                /// check trường hợp không thể thay đổi pass
                } else {
                    this.$el_alert_type(
                        window.vm.$i18n.t("personSet.passwordChangeFail"),
                        "warning"
                    );
                }
                });
            },
            /// Quay lại trang chi tiết
            back() {
                this.$emit("backPageDetails", "personInfo");
            },
    },
};
</script>
<style scoped>
.passContent_infoUser {
    /*width: 239px;*/
    height: 220px;
    padding: 15px 165px;
    background-color: rgba(0, 0, 0, 0.3);
    /* border-radius: 15px; */
    text-align: center;
    padding-bottom: 40px;
    position: relative;
}
.leftdiv {
    width: 200px;
    font-size: 12px;
    margin-top: 20px;
    color: #e8e6e6;
    padding: 8px 10px 10px 10px;
    float: left;
    text-align: left;
    font-weight: 700;
}
.rightdiv {
    float: left;
    text-align: left;
}
.passContent_infoUser input {
    width: 218px;
    /* height: 26px; */
    line-height: 12px;
    margin-top: 20px;
    padding: 8px 10px 10px 10px;
    font-size: 12px;
    color: #e8e6e6;
    border-radius: 15px;
    border: 1px rgba(0, 0, 0, 0) solid;
    /* user-select: none; */
    background-color: rgba(153, 153, 151, 0.3);
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
}
/* .passContent_infoUser input:focus{
		width: 216px;
		padding: 7px 9px 9px 9px;
	} */

.passContent_infoUser p {
    margin-top: 20px;
    font-size: 30px;
    color: #e8e6e6;
    text-align: center;
    margin-bottom: 90px;
    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.45);
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
}

 button {
    width: 80px;
    padding: 5px 10px 7px 10px;
    margin: 30px auto;
    font-size: 12px;
    color: #fff;
    border: 1px #fff solid;
    background: unset;
    border-radius: 15px;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
    transition: 0.5s ease;
}

 button:hover {
    background: #007aff!important;
    color: #fff;
    transition: 0.5s ease;
}
.ss_ud_tt{
    margin-top: 50px !important;
}
.ss_ud_btn {
    margin-top: 35px !important;
}
@media (max-width: 1112px) {
    .passContent_infoUser {
        padding: 15px 150px !important;
    }
}
@media (max-width: 540px) {
    .passContent_infoUser {
        padding: 15px 0px !important;
    }
}
@media (max-width: 480px) {
    .passContent_infoUser {
        padding: 15px 40px !important;
    }
    .passContent_infoUser button {
        margin: 30px auto !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/personSet/infoUser/changerPass.vue